<template>
    <article>
        <section class="author-info">
            {{ author }}:
        </section>
        <section class="text">
            {{ text }}
        </section>
    </article>
</template>

<script>
import { computed } from 'vue';

import { decrypt } from '../message-crypt.js';


export default {
    props: {
        messageBlob: {
            type: String,
            required: true,
        },
        password: {
            type: String,
            required: true,
        },
    },
    setup(props) {
        const message = computed(() => {
            try {
                return decrypt(props.messageBlob, props.password);
            }
            catch(e) {
                console.warn("Unable to decrypt message because of", e);
                return {
                    author: "?",
                    message: "Wrong password supplied. Unable to decrypt.",
                }
            }
        });

        return {
            author: computed(() => message.value.author),
            text: computed(() => message.value.message),
        };
    },
};
</script>

<style scoped>
article {
    border: thin solid #222;
    margin: 1em;
    border-radius: 1em;
    text-align: left;
    padding: 0.5em 1em;
    background-color: #fffcf2;
    overflow-wrap: anywhere;
}

.author-info {
    font-variant-caps: small-caps;
}

.text {
    white-space: pre-wrap;
}
</style>